import React from 'react';
import ReactDOM from 'react-dom';

import ProgressBar from '../challenge_flow/components/ProgressBar';

const node = document.getElementsByClassName('c-progress-bar')[0];

if (node !== undefined) ReactDOM.render(<ProgressBar />, node);
